import Vue from 'vue';
import processor from "./processor";
import getSettingValue from "./getSettingValue";
export function useSetting(settingKey, settingConfig) {
  var settingValue = getSettingValue(settingKey, settingConfig);
  return processor(settingValue, settingConfig);
}
export var globalSetting;
window.useSetting = useSetting;

function settingComputed() {
  var settingConfig = this.$options.setting;
  var settingKey = this.$options.settingKey;
  var settingValue = getSettingValue(settingKey, settingConfig);
  settingValue = processor(settingValue, settingConfig, this);
  return settingValue;
}

Vue && Vue.mixin && Vue.mixin({
  beforeCreate: function beforeCreate() {
    if (this.$options && this.$options.setting) {
      var settingKey = this.$options.settingKey;

      if (!settingKey) {
        throw new Error('请设置组件的settingKey参数才能使用setting功能');
      }

      if (typeof this.$options.computed === 'undefined') this.$options.computed = {};
      this.$options.computed.setting = settingComputed;
    }
  }
});
export function createGlobalSetting(globalSettingKey, globalSetting) {
  var settingValue = getSettingValue(globalSettingKey, globalSetting);
  settingValue = processor(settingValue, globalSetting);
  window.setting = globalSetting = settingValue;
}